import { Default } from '../../../../components/Tags/TagItems/Default';
import { CardState } from '../types';

export const getTagsConfiguration = ({ tags }: Pick<CardState, 'tags'>) => [
  {
    component: Default,
    id: 'Default',
    props: {
      field: 'tags',
      isAllowedToCreateTag: true,
      tags: tags.map((cardTag: any) => cardTag.tag),
    },
  },
];
